import * as Yup from 'yup';

/** @constant {ObjectShape} - Yup Object used for validation schema in feedback form */
const BusinessUsageInfoSchema = Yup.object().shape({
  solutionName: Yup.string().required('Solution name is required'),
  solutionOwner: Yup.string().required('Solution owner is required'),
  organizationUnit: Yup.string(),
  organizationSubUnit: Yup.string(),
  userCustomerName: Yup.string(),
  purpose: Yup.string().required('Purpose is required'),
  uses: Yup.string().required('Uses is required'),
  businessGoals: Yup.string(),
  businessValue: Yup.string(),
  riskTier: Yup.string().required('Risk tier is required'),
  platformName: Yup.string().required('Platform is required'),
  sourceType: Yup.string().required('AI source type is required'),
  publicSubmissionMail: Yup.string().email('Invalid email format'),
  isPublic: Yup.boolean().oneOf([true], 'You must agree to continue'),
});

export { BusinessUsageInfoSchema };
